import React, { useState, useEffect, useMemo, memo } from "react";
import AddCircle from '@mui/icons-material/AddCircleRounded';
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { InputGroup, Button, FormControl, Col} from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";

import { useLocation, Link } from "react-router-dom";

import DataGridKishPortInfo from "./DataGridKishPortInfo";
import ApiKishPortInfo from "../../../../core/api/api.kishPortInfo";
import { CreateEditKishPortInfo } from './CreateOrEdit';

const Index = () => {
    let location = useLocation();


    const [listData, setListData] = useState({});
    const [checkBoxList2, setCheckBoxList2] = useState([]);
    //const [checkBoxList, setcheckBoxList] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [showModalNewContent, setShowModalNewContent] = useState(false);
    const [selectedContent, setSelectedContent] = useState(null);
    const [formInputspromoCategory, setFormInputspromoCategory] = useState(
        { value: -1, label: "انتخاب" }
    );

    const [promoCode, setpromoCode] = useState([]);

    const { register, handleSubmit, control, formState: { errors }, getValues, setValue, watch } = useForm({});
    const methods = { register, handleSubmit, control, formState: { errors }, getValues, setValue, watch };
    useEffect(() => {
        (async () => {
            try {

                const data = await ApiKishPortInfo.getAll({ pageSize: getValues("pageSize"), pageNumber: getValues("pageNumber") });
                // console.log("data ",data)
                setListData(data);
                setValue("totalCount", data.totalCount);





            } catch (error) {
                console.log("error :>> ", error);
            } finally {
            }
        })();

        return () => { };
    }, [refresh]);
    const callBackJustForRunUseEffect = () => {
        setRefresh(!refresh);

    }
    const onSubmit =
        async (data) => {
            const apiData = await ApiKishPortInfo.getAll({
                pageSize: data.pageSize, pageNumber: getValues("pageNumber"),
                globalSearch: data.globalSearch
            });

            setListData(apiData);
        }



    const selectStyles = {

        menu: base => ({
            ...base,
            zIndex: 10000
        })
    }
    const inputChangeHandlerPromoCategory = (event) => {
        setValue("promoCategoryId", { value: event.value, label: event.label })
    }
    const inputChangeHandlerAgent = (event) => {
        setValue("agentId", { value: event.value, label: event.label })
    }
    const inputChangeHandlerPromoCategoryCommision = (event) => {
        setValue("promoCategoryCommisionId", { value: event.value, label: event.label })
    }
    return (

        <div>
            {/* {console.log(location)}
               {(!_.isEmpty(location.state) && location.state?.neWPromoCode) ?
            <NewPromoCodeModal callback={callBackJustForRunUseEffect} />
            : location?.state?.neWPromoCode?.promoCodeId > 0  ?  <NewPromoCodeModal  callback={callBackJustForRunUseEffect}/> : 
            <></>
        } */}
            <div className={`card card-custom`}>
                {/* Start Box Header */}
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            مدیریت لیست اطلاعیه های بندرگاه ها
                        </span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">
                            لیست اطلاعیه های بندرگاه ها
                        </span>
                    </h3>
                    <div className="card-toolbar">

                        {/* <Link variant="success" className="btn btn-success"
                            key={0}
                            to={{
                                pathname: "/createOrEditKishPortInfo/0",
                                state: { neWKishPortInfo: true }
                            }}
                        >
                            <AddCircle className='mr-1' />
                                ایجاد محتوای جدید
                             </Link> */}
                        <Button className="btn btn-success"
                            onClick={() => {
                                setSelectedContent(0);
                                setShowModalNewContent(true);
                            }}
                        >
                            <AddCircle className='mr-1' />
                            ایجاد محتوای جدید
                        </Button>

                    </div>
                </div>






                {/*Start body */}
                <div className="card-body pt-3 pb-0">
                    <FormProvider {...methods} >
                        <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>

                            <div className='border-top pt-3'>

                                <InputGroup className="mb-3">
                                    <Controller
                                        name="globalSearch"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <FormControl
                                                type="text"
                                                aria-describedby="basic-addon1"
                                                placeholder='جستجو ...'
                                                name="globalSearch"
                                                value={value || ""}
                                                onChange={onChange}
                                            />
                                        )}
                                    />

                                    <Button variant="secondary" type="submit"><SearchIcon /></Button>

                                </InputGroup>
                            </div>

                            {/* table */}
                            <Col xs='12' className='tb-reponsive px-0'>
                                {<DataGridKishPortInfo data={listData} setCheckBoxList2={setCheckBoxList2} callBack={callBackJustForRunUseEffect}
                                    setShowModalNewContent={setShowModalNewContent} setSelectedContent={setSelectedContent}
                                />}
                            </Col>
                            {showModalNewContent && (
                                <CreateEditKishPortInfo
                                    showModalNewContent={showModalNewContent}
                                    setShowModalNewContent={setShowModalNewContent}
                                    selectedContent={selectedContent}
                                />
                            )}
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div>

    );
};

export default Index;

